/**
 * usePlaybackControl Hook
 * 
 * Manages playback control operations
 */

import { useCallback } from 'react';
import PlaybackService from '../../../services/transcript/PlaybackService';

/**
 * Hook for playback control
 * @param {Array} blocks - Transcript blocks
 * @param {Function} seekToBlock - Function to seek to block
 * @param {Function} seekTo - Function to seek to time
 * @param {Function} play - Function to play video
 * @returns {Object} Playback control functions
 */
const usePlaybackControl = (blocks, seekToBlock, seekTo, play) => {
  /**
   * Play from text selection
   */
  const playFromSelection = useCallback(
    async (selection) => {
      const result = await PlaybackService.playFromSelection(
        selection,
        blocks,
        seekToBlock,
        seekTo,
        play
      );
      return result;
    },
    [blocks, seekToBlock, seekTo, play]
  );

  return {
    playFromSelection,
  };
};

export default usePlaybackControl;

